import { QueryStore } from './QueryStore';
import { QueryAnalyzer } from './QueryAnalyzer';

export class QueryExporter {
  constructor(
    private queryStore: QueryStore,
    private queryAnalyzer: QueryAnalyzer,
  ) {}

  exportAsJSON(): string {
    const queries = this.queryStore.getQueries();
    const exportData = {
      timestamp: new Date().toISOString(),
      totalQueries: queries.length,
      queries: queries.map(q => ({
        componentName: q.componentName,
        queryKey: q.queryKey,
        query: q.query,
        url: q.url,
        duration: q.duration,
        status: q.status,
      })),
      byComponent: this.queryAnalyzer.getQueriesByComponent(),
    };

    return JSON.stringify(exportData, null, 2);
  }
}
